import React from 'react'

interface AcademyLogoProps {
  className?: string
}

const AcademyLogo: React.FC<AcademyLogoProps> = ({ className }) => (
  <img
    src="/logo-white.svg"
    alt="Academy"
    className={className}
    style={{ width: 140, height: 'auto' }}
  />
)

export default AcademyLogo
